var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "pui-grid-container",
        [
          _c(
            "pui-grid-row",
            [
              _c(
                "pui-grid-column",
                { attrs: { cols: 12 } },
                [
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: { s: 12, l: 4 },
                          expression: "{s:12, l:4}",
                        },
                      ],
                      attrs: {
                        "has-cta": "",
                        label: _vm.$t("info.hierarchicalSystem"),
                        "cta-label": _vm.$t("info.clearSelection"),
                        "cta-callback": _vm.abortFunctionalLocationSelection,
                      },
                    },
                    [
                      _c("pui-form-type-ahead", {
                        staticClass: "functional-location-type-ahead",
                        attrs: {
                          options: _vm.functionalLocationOptions,
                          "is-disabled": _vm.isReadOnly,
                          "is-valid": _vm.isFunctionalLocationValid,
                          multiple: false,
                          "search-input-debounce-time": 500,
                          "max-visible-options": 5,
                          "search-input-min-length": 0,
                          "use-local-cache": false,
                          label: _vm.$t("info.hierarchicalSystem"),
                          "search-input-placeholder": _vm.$t(
                            "info.searchForFunctionalLocation"
                          ),
                          "is-loading": _vm.isLoadingFunctionalLocation,
                        },
                        on: {
                          search: _vm.searchFunctionalLocations,
                          change: _vm.selectFunctionalLocation,
                        },
                        model: {
                          value: _vm.selectedFunctionalLocationOption,
                          callback: function ($$v) {
                            _vm.selectedFunctionalLocationOption = $$v
                          },
                          expression: "selectedFunctionalLocationOption",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: 12,
                          expression: "12",
                        },
                      ],
                      attrs: {
                        label: _vm.$t("info.mainSystem"),
                        "label-for": "mainSystemDropdown",
                      },
                    },
                    [
                      _c("pui-form-select", {
                        key: _vm.mainSystemSelectRefreshKey,
                        attrs: {
                          id: "mainSystemDropdown",
                          label: _vm.$t("info.mainSystem"),
                          "search-input-id": "mainSystemDropdown",
                          "search-input-placeholder": _vm.$t("placeholder"),
                          value: _vm.currentState.eventSapMainSystem,
                          options: _vm.selectOptions.mainSystems,
                          "is-disabled": _vm.isReadOnly,
                        },
                        on: { change: _vm.selectedMainSystemChanged },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "pui-form-group",
                    {
                      directives: [
                        {
                          name: "pui-form-grid-column",
                          rawName: "v-pui-form-grid-column",
                          value: 12,
                          expression: "12",
                        },
                      ],
                      attrs: {
                        label: _vm.$t("info.subSystem"),
                        "label-for": "subSystemDropdown",
                      },
                    },
                    [
                      _c("pui-form-select", {
                        key: _vm.subSystemSelectRefreshKey,
                        attrs: {
                          id: "subSystemDropdown",
                          label: _vm.$t("info.subSystem"),
                          "search-input-id": "subSystemDropdown",
                          "search-input-placeholder": _vm.$t("placeholder"),
                          options: _vm.selectOptions.subSystems,
                          "is-disabled": _vm.isReadOnly,
                        },
                        model: {
                          value: _vm.currentState.eventSapSubSystem,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentState, "eventSapSubSystem", $$v)
                          },
                          expression: "currentState.eventSapSubSystem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }